import { components } from "react-select";

// Custom Option with checkbox
const Option = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 10 }}
        />
        {props.label}
      </components.Option>
    );
};

export {Option};
// Custom ValueContainer to prevent height growth
const ValueContainer = ({ children, ...props }) => {
  // const selected = props.getValue();
  const selected = props.getValue().filter((v) => v.value !== '*');
  const [placeholder, input] = children;
  

  return (
    // <components.ValueContainer {...props}>
    //   {selected.length > 0 ? `${selected.length} brands selected` : children}
    // </components.ValueContainer>
    <components.ValueContainer {...props}>
    {selected.length > 0 ? (
      
      <div style={{ marginRight: 8 }}>
        {`${selected.length} selected`}
      </div>
    ) : (placeholder)}
    {input}
    
    </components.ValueContainer>
  );
};


export {ValueContainer};